export interface PaymentsDeps {
  isTelegramMiniApp: Readonly<Ref<boolean>>
  isAuthenticated: Readonly<Ref<boolean>>
  isJustRegisteredUser: Ref<boolean>
  isUserSettingsSet: Readonly<Ref<boolean>>
  updateUserPreferredCurrencyCode: (currencyCode: string) => Promise<void>
  userEmail: Readonly<Ref<string>>
  hasTelegramAuthProvider: Readonly<Ref<boolean>>
  hasWalletConnectAuthProvider: Readonly<Ref<boolean>>
  preferredCurrencyCode: Readonly<Ref<string>>
  preferredAccountType: Readonly<Ref<'real' | 'bonus' | 'freebet'>>
  showZeroAccounts: Readonly<Ref<boolean>>
  preferredCurrencyCodeForCurrencyExchange: Readonly<Ref<string>>
  updateUserSettings: (
    settings: { name: string; value: unknown }[],
  ) => Promise<void>
  DepositBonusBanner: Component<{
    selectedCurrencyCode?: string
  }>
}

export const [usePaymentsDeps, providePaymentsDeps] =
  createEntityDeps<PaymentsDeps>('payments')
